import { MeasurementTypes } from "../../enums/kpiStats/measurement-types.enum";

export function isUptrendPositive(measurementType: MeasurementTypes): boolean {
  if (measurementType === MeasurementTypes.Volume) {
    return false;
  }

  if (measurementType === MeasurementTypes.FuelEconomy) {
    return true;
  }

  if (measurementType === MeasurementTypes.FuelConsumption) {
    return false;
  }

  if (measurementType === MeasurementTypes.Percentage) {
    return false;
  }

  if (measurementType === MeasurementTypes.CostPerUnit) {
    return false;
  }

  if (measurementType === MeasurementTypes.Hours) {
    return false;
  }

  return true;
}